import Api from '../api';
import Config from '../config/config';
const UseGuest = () => {

     const SignIn=({data,onSuccess,onError,loader})=>{
       data = {...data,reactive:true}
        Api.Guest.SignIn({ data,loader })
          .then(response=>{
              if(response.status){
                window.localStorage.setItem("showVerificationBanner","on")
                window.localStorage.setItem("showFeeMessage","on")
                window.localStorage.setItem("showSmsAddsMessage","on")
                if(response.status && window.trackLeaderBet){
                  window.trackLeaderBet("SignIn")
                }
                onSuccess()
              }else{
                  onError(response.data)
              }
          })
    }

  const SignInWithoutCallback=({data,loader})=>{
    return new Promise((resolve)=>{
      Api.Guest.SignIn({ data,loader }).then(response=>{
          if(response.status){
            window.localStorage.setItem("showVerificationBanner","on")
            window.localStorage.setItem("showFeeMessage","on")
            window.localStorage.setItem("showSmsAddsMessage","on")
          }
          if(response.status && window.trackLeaderBet){
            window.trackLeaderBet("SignIn")
          }
          resolve(response)
      })
    })

  }

    return {SignIn,SignInWithoutCallback}
};
export default UseGuest;
